import axios from 'axios'
import { errorHandler } from '../exports/error_management'
const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)
const api = async (method, path, params) => axios[method](path, params)
function isValidPayload(payload) {
    if (!payload || !payload.file.name || !payload.file.id ) {
        return false
    }
    return true
}
const state = {
    attachments: [],
    itemsChanged: false,
}

const getters = {}

const mutations = {
    SET_ATTACHMENTS(state, attachments) {
        state.attachments = attachments
    },
    SET_CHANGED(state, x) {
        state.itemsChanged = x
    },
    clearAssetAttachments(state) {
        state.attachments = [];
    },
}

const actions = {
    load({ commit }, initialItems) {
        const attachments = initialItems.map(x => {
            x.hash = x.hash || getHash()
            return x
        })
        commit('SET_ATTACHMENTS', attachments)
        commit('SET_CHANGED', false)
    },

    clear({ commit }) {
        commit('SET_ATTACHMENTS', [])
        commit('SET_CHANGED', false)
    },

    merge({ state, commit }, items) {
        items.newFiles.forEach(item => {
            item.hash = item.hash || getHash()
            const attachments = [...state.attachments]
            let index = attachments.findIndex(x => x.hash == item.hash)
            if (index >= 0) attachments.splice(index, 1, item)
            else attachments.push(item)
            commit('SET_CHANGED', true)
            commit('SET_ATTACHMENTS', attachments)
        })
    },
    async renameAttachment(context, payload) {
        try {
            if (!isValidPayload(payload)) throw new Error('Data Required')
            await api('put', `asset/rename/attachment/${payload.file.id}`, {
                name: payload.file.name,
            })
        } catch (err) {
            errorHandler(err)
        }
    },

    delete({ state, commit }, hash) {
        const attachments = [...state.attachments]
        const index = attachments.findIndex(x => x.hash == hash)
        attachments.splice(index, 1)
        commit('SET_CHANGED', true)
        commit('SET_ATTACHMENTS', attachments)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
